import { Component } from "vue-property-decorator";
import Base from "./Base";
import { API_ENDPOINT } from "@/constants";

export const GET_MODULE_TYPOLOGIES_TAG = "get_module_typologies";

@Component
export default class ModuleTypology extends Base {
  getModuleTypologies() {
    const path = `${API_ENDPOINT}/special_initiatives/module_typologies`;
    return this.$store.dispatch("http/request", {
      tag: GET_MODULE_TYPOLOGIES_TAG,
      url: path,
      method: "GET",
    });
  }
}
